<div class="cat">
  <!-- ── Left sidebar ───────────────────────────────────────────────────── -->
  <asset-catalog-filters
    [filters]="assetListFilters()"
    (filterChange)="assetListFilters.update($event)"
    [clearFilters]="clearFilters"
  />

  <!-- ── Main content ───────────────────────────────────────────────────── -->
  <main class="cat__main">
    <!-- Page header + search row -->
    <div class="cat__page-header">
      <div class="cat__page-meta">
        <h1 class="cat__page-title">All Assets</h1>
        <p class="cat__page-desc">
          Explore datasets, AI agents, tools, portals, and platforms from ADB and partner
          organisation.
        </p>
      </div>
      <div class="cat__search-wrap">
        <svg
          class="cat__search-icon"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          class="cat__search"
          type="text"
          placeholder="Filter assets by keywords"
          [(ngModel)]="searchValue"
        />
        @if (hasFilters()) {
          <button class="cat__search-clear" (click)="clearFilters()">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
            Clear
          </button>
        }
      </div>
    </div>

    <!-- Hero banner -->
    <!-- TODO: use when have values to obtain -->
    <!-- @if (!hasFilters()) { -->
    <!--   <div class="cat__hero-card"> -->
    <!--     <div class="cat__hero-inner"> -->
    <!--       <div class="cat__hero-text"> -->
    <!--         <p class="cat__hero-eyebrow">Latest Updates</p> -->
    <!--         <h2 class="cat__hero-title">Fresh additions to DataNex+</h2> -->
    <!--         <button class="cat__hero-btn" (click)="browseNew()">Explore new additions</button> -->
    <!--       </div> -->
    <!--       <div class="cat__hero-stats" aria-hidden="true"> -->
    <!--         <div class="cat__hero-stat"> -->
    <!--           <span class="cat__hero-stat-n">47</span> -->
    <!--           <span class="cat__hero-stat-l">Datasets</span> -->
    <!--         </div> -->
    <!--         <div class="cat__hero-stat-divider"></div> -->
    <!--         <div class="cat__hero-stat"> -->
    <!--           <span class="cat__hero-stat-n">6</span> -->
    <!--           <span class="cat__hero-stat-l">AI Agents</span> -->
    <!--         </div> -->
    <!--         <div class="cat__hero-stat-divider"></div> -->
    <!--         <div class="cat__hero-stat"> -->
    <!--           <span class="cat__hero-stat-n">3</span> -->
    <!--           <span class="cat__hero-stat-l">Dashboards</span> -->
    <!--         </div> -->
    <!--       </div> -->
    <!--     </div> -->
    <!--   </div> -->
    <!-- } -->

    <div class="cat__card-container">
      @if (assetsList.isLoading()) {
        <loader size="64px" />
      } @else if (hasFilters()) {
        <div class="cat__section">
          <div class="cat__section-header">
            <h3 class="cat__section-title">Results</h3>
          </div>
          <div class="cat__grid">
            @for (asset of assetsList.value()?.items; track asset.asset_id) {
              <asset-card [asset]="asset" [isGrid]="true" />
            }
          </div>
        </div>
      } @else {
        @for (assetType of sortedAssets(); track assetType[0]) {
          @if (assetType[1].length > 0) {
            <div class="cat__section">
              <div class="cat__section-header">
                <h3 class="cat__section-title">{{ assetType[0] }}</h3>
                <span class="cat__see-all" (click)="handleSectionSeeAllClick(assetType[0])"
                  >See all</span
                >
              </div>
              <div class="cat__grid">
                @for (asset of assetType[1]; track asset.asset_id) {
                  <asset-card [asset]="asset" [isGrid]="true" />
                }
              </div>
            </div>
          }
        }
      }
    </div>
  </main>
</div>
